import { Entry } from './entry';

Entry.displayName = 'Typography';

export { Entry as Typography };
